// File Metadata:
// Filename: Prefetch.js
// Version: 1.00
// Created: 2022-09-28 21:44:33
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { store } from '../../app/store'
import { receptionsApiSlice } from '../api/receptionsApiSlice'
import { usersApiSlice } from '../api/usersApiSlice'
import { vendorsApiSlice } from '../api/vendorsApiSlice'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

const Prefetch = () => {
	useEffect(() => {
		store.dispatch(receptionsApiSlice.util.prefetch('getReceptions', 'receptionsList', { force: true }))
		store.dispatch(usersApiSlice.util.prefetch('getUsers', 'usersList', { force: true }))
		store.dispatch(vendorsApiSlice.util.prefetch('getVendors', 'vendorsList', { force: true }))
	}, [])

	return <Outlet />
}

export default Prefetch
